import { ComponentProps, ReactNode } from "react";
import { useDialogState } from "./Hooks/useDialogState";
import { DialogProvider } from "@/lib/Components/Dialog/Providers/DialogProvider";
import { Alert } from "@/components/catalyst/alert";

export function AlertDialog({
  children,
  onClose,
  className,
  size,
}: {
  children: ReactNode;
  onClose?: () => void;
  className?: string;
  size?: ComponentProps<typeof Alert>["size"];
}) {
  const { close, isOpen, depth, reject } = useDialogState();

  return (
    <Alert
      open={isOpen}
      onClose={async () => {
        onClose?.();
        reject?.("dialog closed");
        await close();
      }}
      className={className}
      size={size}
    >
      <DialogProvider depth={depth + 1}>{children}</DialogProvider>
    </Alert>
  );
}
